export const ESCAPE_MODE_OPTIONS = ['undefined', 'no_escape', 'escape'];
